import React from "react";

export type AccountContainerContextType = {
  isIndividual: boolean;
};

export const AccountContainerContext = React.createContext<AccountContainerContextType | null>(
  null
);

export const useAccountContainerContext = () => {
  const context = React.useContext(AccountContainerContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
